/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-07-16 11:07:25
 */
import { defineStore } from 'pinia';
import { logins as userLogin, logout as userLogout, getUserProfile, LoginData } from '@/api/user/index';
import { setToken, clearToken } from '@/utils/auth';
import { UserState } from './types';

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    role: {},
    isSysTem: false,
  }),
  getters: {},
  actions: {
    // 设置用户的信息
    setRoleList<T extends { userName?: string }>(current: T) {
      console.log('setRoleList', current);
      this.role = current;
      if (current && current.userName === 'admin') {
        this.isSysTem = true;
      } else {
        this.isSysTem = false;
      }
    },
    // 重置用户信息
    resetInfo() {
      this.role = {};
      this.$reset();
    },
    // 获取用户信息
    async info() {
      const result = await getUserProfile();
      this.setRoleList(result);
    },
    // 异步登录并存储token
    async login(loginForm: LoginData) {
      try {
        const res = await userLogin(loginForm);
        const token = res?.access_token;
        if (token) {
          setToken(token);
          this.info();
        }
        return res;
      } catch (error) {
        console.log(error);
        clearToken();
        throw error;
      }
    },
    // Logout
    async logout() {
      await userLogout().catch(() => {});
      this.resetInfo();
      clearToken();
      // 路由表重置
      setTimeout(() => {
        // 打回登录页面
        window.location.href = '/login';
      }, 1000);
    },
  },
  persist: {
    storage: localStorage,
  },
});
